import ProductContain from "./Product-Contain";
import NewFooter from "./new-footer";
function ProductOnly() {
    return (
        <>
            <ProductContain />
            <NewFooter />
        </>
    )
}
export default ProductOnly;